import * as THREE from "three";
import { Game } from "./game";
import { Sfx } from "./sfx";
import type { InputState } from "./types";

const canvas = document.querySelector<HTMLCanvasElement>("#game");
if (!canvas) throw new Error("canvas #game missing");

const renderer = new THREE.WebGLRenderer({ canvas, antialias: true });
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

const scene = new THREE.Scene();
scene.background = new THREE.Color(0x5c94fc);
scene.fog = new THREE.Fog(0x5c94fc, 25, 60);

const camera = new THREE.PerspectiveCamera(55, 1, 0.1, 200);
camera.position.set(7, 5, 13);

const ambient = new THREE.AmbientLight(0xffffff, 0.85);
scene.add(ambient);
const sun = new THREE.DirectionalLight(0xffffff, 0.9);
sun.position.set(5, 12, 8);
scene.add(sun);

const sfx = new Sfx();
const game = new Game(scene, camera, sfx);

const hud = {
  score: document.getElementById("hud-score")!,
  coins: document.getElementById("hud-coins")!,
  world: document.getElementById("hud-world")!,
  time: document.getElementById("hud-time")!,
  lives: document.getElementById("hud-lives")!,
  message: document.getElementById("hud-message")!
};

function pad(n: number, w: number): string {
  return String(n).padStart(w, "0");
}

game.onHud = (info) => {
  hud.score.textContent = pad(info.score, 6);
  hud.coins.textContent = `\u00d7 ${pad(info.coins, 2)}`;
  hud.world.textContent = info.world;
  hud.time.textContent = pad(info.time, 3);
  hud.lives.textContent = `\u00d7 ${info.lives}`;
  hud.message.textContent = info.message;
  hud.message.style.display = info.message ? "block" : "none";
};

// ---- input ----

const keys = new Set<string>();
let jumpQueued = false;

window.addEventListener("keydown", (e) => {
  if (["Space", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.code)) {
    e.preventDefault();
  }
  if (e.code === "Space" && !e.repeat) jumpQueued = true;
  keys.add(e.code);
  sfx.resume();
});
window.addEventListener("keyup", (e) => {
  keys.delete(e.code);
});

function readInput(): InputState {
  const input: InputState = {
    left: keys.has("KeyA") || keys.has("ArrowLeft"),
    right: keys.has("KeyD") || keys.has("ArrowRight"),
    run: keys.has("KeyW") || keys.has("ArrowUp"),
    jump: keys.has("Space"),
    jumpPressed: jumpQueued,
    down: keys.has("KeyS") || keys.has("ArrowDown")
  };
  jumpQueued = false;
  return input;
}

// ---- resize ----

function resize(): void {
  const w = window.innerWidth;
  const h = window.innerHeight;
  renderer.setSize(w, h);
  camera.aspect = w / h;
  camera.updateProjectionMatrix();
}
window.addEventListener("resize", resize);
resize();

// ---- loop ----

let last = 0;

function frame(): void {
  requestAnimationFrame(frame);
  const now = performance.now();
  const dt = Math.min((now - last) / 1000, 0.1);
  last = now;
  game.update(dt, readInput());
  renderer.render(scene, camera);
}
last = performance.now();
requestAnimationFrame(frame);
